<template>
  <div>
    <button class="btn btn-success" @click="goToExport()">
      匯出表單
    </button>
  </div>
</template>

<script>
import { axiosMixins } from '../mixins/axiosErrorMessage';

export default {
  props: ['channelName', 'logType', 'bxMac', 'requestDate'],
  mixins: [axiosMixins],
  data() {
    return {
      base_url,
    }
  },
  methods: {
    goToExport() {
      const year = this.$props.requestDate.split("-")[0];
      const month = this.$props.requestDate.split("-")[1];
      const day = this.$props.requestDate.split("-")[2];
      const channel = this.$props.channelName[0];
      const mac = this.$props.bxMac;
      const action = this.$props.logType;
      const route_link = base_url + '/api/bx/export?year=' + year + '&month=' + month + '&day=' + day + '&channel=' + channel + '&mac=' + mac + '&action=' + action;
      axios
        .get(
          route_link,
          { responseType: 'blob' }
        )
        .then((response) => {
          //利用回傳的資料產生一個暫時的連結
          const url = window.URL.createObjectURL(new Blob([response.data]));

          //動態建立一個<a>標籤
          const link = document.createElement('a');

          //標籤中設定屬性link為剛產生的連結
          link.href = url;

          //從回傳資料的header中取得檔案名稱字串
          const fileName = decodeURI(response.headers["content-disposition"]
            .split(" ")[1]
            .replace("filename=", ""));

          //設定連結的download屬性並指定檔名
          link.setAttribute('download', fileName);

          //把產生的<a>標籤物件加入到頁面中
          document.body.appendChild(link);

          //觸發點擊事件讓下載開始
          link.click();
        }).catch(error => this.axiosMessage(error));
    },
  },
}
</script>

<style scoped>
.btn {
  font-size: .8rem;
}
</style>
